// extracted by mini-css-extract-plugin
export var details = "_in-0";
export var inspectorPopover = "_in-1";